import { MNSproCloudApi } from '..';
import { UserPreferencesModules } from './userPreferences.interfaces';

export class UserPreferencesService {
  static async getAllUserPreferences(authToken: string) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.UserPreferencesApiFactory(config);

    const prefs = await api.getAll();
    return prefs.data;
  }

  static async getModuleUserPreferences(
    authToken: string,
    prefModule: UserPreferencesModules,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.UserPreferencesApiFactory(config);

    const rights = await api.get(prefModule);
    return rights.data;
  }

  static async patchModule(
    authToken: string,
    prefModule: UserPreferencesModules,
    value: object,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.UserPreferencesApiFactory(config);

    const rights = await api.patchModule(prefModule, value);
    return rights.data;
  }
}
